import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { chatApi as r } from "@maat/api-chat";
//#region src/hooks/useCreateInboxConversationMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.createInboxConversation(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.conversations() });
		}
	});
};
//#endregion
export { i as useCreateInboxConversationMutation };
